// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"850":"a51796b7","987":"6e9fc26f"}[chunkId] + ".css";
};